function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import { Text } from '../Text';

var getMaxWidth = function getMaxWidth(em) {
  return parseInt(em) - 0.01;
};

var breakpoints = function breakpoints(props) {
  return {
    xs: "@media screen and (max-width: ".concat(getMaxWidth(props.theme.breakpoints[0]), "em)"),
    sm: "@media screen and (min-width: ".concat(props.theme.breakpoints[0], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[1]), "em)"),
    md: "@media screen and (min-width: ".concat(props.theme.breakpoints[1], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[2]), "em)"),
    lg: "@media screen and (min-width: ".concat(props.theme.breakpoints[2], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[3]), "em)"),
    xl: "@media screen and (min-width: ".concat(props.theme.breakpoints[3], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[4]), "em)"),
    xxl: "@media screen and (min-width: ".concat(props.theme.breakpoints[4], ")"),
    print: "@media print"
  };
};

var hidden = function hidden(key) {
  return function (props) {
    return props[key] ? _defineProperty({}, breakpoints(props)[key], {
      display: 'none'
    }) : null;
  };
};

var Hide = styled(Box).withConfig({
  displayName: "Hide",
  componentId: "sc-16m85mi-0"
})(["", " ", " ", " ", " ", " ", " ", ";"], hidden('xs'), hidden('sm'), hidden('md'), hidden('lg'), hidden('xl'), hidden('xxl'), hidden('print'));
Hide.propTypes = {
  xs: PropTypes.bool,
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  xl: PropTypes.bool,
  xxl: PropTypes.bool,
  print: PropTypes.bool
};
Hide.displayName = 'Hide';
Hide.text = styled(Text).withConfig({
  displayName: "Hide__text",
  componentId: "sc-16m85mi-1"
})(["display:inline;", " ", " ", " ", " ", " ", " ", ";"], hidden('xs'), hidden('sm'), hidden('md'), hidden('lg'), hidden('xl'), hidden('xxl'), hidden('print'));
export default Hide;